import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
//import BasicCard from 'src/common/components/card/basicCard/BasicCard';
import Card from 'src/common/refactoredComponents/card/Card';
import {
    UsagePricingCardContainer,
    UsagePricingContainer,
    UsagePricingDataContainer,
    UsagePriceFont,
} from './UsagePricing.styled';
import { setCurrencyFormat, setItemsDataHandler } from 'src/utils/util';
import BundleCards from 'src/pages/orders/components/orderDetails/billingSummary/shippedItems/bundleCards';
import BillingSummaryDataTableEquity from 'src/pages/orders/components/orderDetails/billingSummary/shippedItems/BillingSummaryDataTableEquity';
import { priceFormatObj } from 'src/pages/consignmentBilling/utils/eventHandlerUtil';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const shippedItems = ({
    isShippedItems,
    toggleCard,
    handleSetItemClick,
    isBillingSummary,
}) => {
    //need to be uncommented for api data
    const { t } = useTranslation();
    const usagePrice = useSelector(
        (state) => state.orderSummaryReducer.billingSummary?.usagePricing
    );
    const ISOCountryCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const [usagePricing, setUsagePricing] = useState([]);
    const [checkUsagePricing] = useState([]);
    const [expandRow, setExpandRow] = useState(null);

    const usagePricingCartSummary = useSelector(
        (state) => state.orderSummaryReducer.billingSummary?.cartSummary
    );

    const currencyISOCode = useSelector(
        (state) =>
            state.orderSummaryReducer.billingSummary?.cartSummary
                ?.currencyISOCode
    );

    const { poDetails, total, pricingNotes, tissuePrice, nonTissuePrice } =
        usagePricingCartSummary || {};
    useEffectWithErrorLogging(() => {
        if (usagePrice) {
            usagePrice.map((item) => {
                if (Object.keys(item).length) {
                    checkUsagePricing.push(item);
                }
            });
            setUsagePricing(checkUsagePricing);
        }
    }, [usagePrice]);

    const setItemHandler = (data, orderList) => {
        const setItemDetails = setItemsDataHandler(data, orderList);
        handleSetItemClick(setItemDetails);
    };

    const mobileSubItemsColumns = [
        {
            field: 'subItemsDescription',
            header: t('orders.shipTrackLabels.productItemDescriptionLabel'),
            width: '75%',
        },
        {
            field: 'quantity',
            header: t('reportUsage.summary.quantity'),
            width: '20%',
        },
    ];

    const updateRowExpandHandler = (expandRow) => {
        setExpandRow(expandRow);
    };

    const formatCurrency = (amt) =>
        // new Intl.NumberFormat(undefined, {
        //     style: 'currency',
        //     currency: 'USD',
        // }).format(amt);
        setCurrencyFormat(amt, true, { currency: currencyISOCode });

    const checkBundle =
        usagePrice?.filter((x) => x.isBundleHeader)?.length > 0 ? true : false;

    return (
        <>
            <CollapsableCard
                id="orders-shippedItems-shippedItems-shippedItems"
                title={`${t('orders.orderStatuses.shippeditems')} (${
                    usagePricing?.length
                })`}
                titleFontSize={'15px'}
                onClick={() => toggleCard('isShippedItems', !isShippedItems)}
                isExpanded={isShippedItems}
                padding={'0.8rem'}
                // CollapsableCardIconWidthHeight={'12px'}
                CollapsableIconMarginRight={'0px 3px 0px 0px'}
                cursor={'pointer'}
            >
                {isShippedItems && usagePricing ? (
                    <>
                        <BillingSummaryDataTableEquity
                            data={usagePricing}
                            isBundleTable={checkBundle}
                            keyValue={'cfn'}
                            bundleSubGroup={'bundleItems'}
                            rowExpand={expandRow}
                            setItemHandler={setItemHandler}
                            updateRowExpandHandler={updateRowExpandHandler}
                        />
                        {isShippedItems && usagePricing ? (
                            <>
                                {usagePricing?.length > 0 ? (
                                    <>
                                        {usagePricing.map(
                                            (usagePrice, index) => {
                                                const isBundle =
                                                    usagePrice?.isBundleHeader
                                                        ? usagePrice.isBundleHeader
                                                        : false;
                                                return (
                                                    <UsagePricingCardContainer
                                                        key={
                                                            index +
                                                            usagePrice.cfn
                                                        }
                                                        //key={index}
                                                    >
                                                        <BundleCards
                                                            keyIndex={
                                                                usagePrice.cfn
                                                            }
                                                            isBundle={isBundle}
                                                            setItemHandler={
                                                                setItemHandler
                                                            }
                                                            isBillingSummary={
                                                                isBillingSummary
                                                            }
                                                            setDetailsData={
                                                                usagePrice
                                                            }
                                                            cfn={usagePrice.cfn}
                                                            quantity={
                                                                usagePrice.quantity
                                                            }
                                                            serialNo={
                                                                usagePrice.serialNo
                                                            }
                                                            description={
                                                                usagePrice.description
                                                            }
                                                            isEquity={true}
                                                            // poNumber={
                                                            //     usagePrice.poNumber
                                                            // }
                                                            status={
                                                                usagePrice.status
                                                            }
                                                            unitPrice={
                                                                usagePrice.unitPrice
                                                            }
                                                            subUnitPrice={
                                                                usagePrice.overridenUnitPrice
                                                            }
                                                            extPrice={
                                                                usagePrice.extPrice
                                                            }
                                                            subExtPrice={
                                                                usagePrice.overridenExtPrice
                                                            }
                                                            subItemsData={
                                                                isBundle
                                                                    ? usagePrice.bundleItems
                                                                    : []
                                                            }
                                                            subItemsColumns={
                                                                isBundle
                                                                    ? mobileSubItemsColumns
                                                                    : []
                                                            }
                                                            descriptionMobileFontSize={
                                                                '13px'
                                                            }
                                                            isUsed={
                                                                usagePrice.isUsed
                                                            }
                                                        />
                                                    </UsagePricingCardContainer>
                                                );
                                            }
                                        )}
                                    </>
                                ) : null}
                            </>
                        ) : null}
                        {usagePricingCartSummary ? (
                            <Card
                                padding={'10px 25px'}
                                margin={'10px 0 0 0'}
                            >
                                <UsagePricingContainer>
                                    <UsagePriceFont
                                        color="#140F4B"
                                        fontFamily="AvenirNextWorld Demi"
                                        margin={'0 0 10px 0'}
                                        fontSize="15px"
                                        letterSpacing="-0.12px"
                                    >
                                        {t('reportUsage.summary.title')}
                                    </UsagePriceFont>
                                    {/* {cartItems ? (
                                        <UsagePricingDataContainer
                                            margin={'0 0 5px 0'}
                                            justifyContent="space-between"
                                        >
                                            <UsagePriceFont
                                                color="#4F4F4F"
                                                fontSize="15px"
                                                letterSpacing="-0.12px"
                                                lineHeight="23px"
                                            >
                                               
                                                {'Cart'}
                                            </UsagePriceFont>
                                            <UsagePriceFont
                                                color="#4F4F4F"
                                                fontSize="15px"
                                                letterSpacing="-0.12px"
                                                lineHeight="23px"
                                            >
                                                {cartItems +'Items'}
                                            </UsagePriceFont>
                                        </UsagePricingDataContainer>
                                    ) : null} */}
                                    {poDetails && poDetails?.length > 0 ? (
                                        <>
                                            {poDetails?.map(
                                                (poDetail, index) => {
                                                    return (
                                                        <UsagePricingDataContainer
                                                            key={index}
                                                            margin={'0 0 5px 0'}
                                                            justifyContent="space-between"
                                                        >
                                                            <UsagePriceFont
                                                                color="#4F4F4F"
                                                                fontSize="15px"
                                                                letterSpacing="-0.12px"
                                                                lineHeight="23px"
                                                            >
                                                                {/* {`PO: ${ */}
                                                                {`${t(
                                                                    'reportUsage.summary.nonTissue'
                                                                )} ${
                                                                    poDetail?.poNumber
                                                                        ? poDetail.poNumber
                                                                        : ''
                                                                }`}
                                                            </UsagePriceFont>
                                                            <UsagePriceFont
                                                                color="#4F4F4F"
                                                                fontSize="15px"
                                                                letterSpacing="-0.12px"
                                                                lineHeight="23px"
                                                            >
                                                                {setCurrencyFormat(
                                                                    poDetail?.price,
                                                                    true,
                                                                    {
                                                                        currency:
                                                                            currencyISOCode,
                                                                    }
                                                                )}
                                                            </UsagePriceFont>
                                                        </UsagePricingDataContainer>
                                                    );
                                                }
                                            )}
                                        </>
                                    ) : null}
                                    {tissuePrice || tissuePrice === 0 ? (
                                        <UsagePricingDataContainer
                                            margin={'0 0 5px 0'}
                                            justifyContent="space-between"
                                        >
                                            <UsagePriceFont
                                                color="#4F4F4F"
                                                fontSize="15px"
                                                letterSpacing="-0.12px"
                                                lineHeight="23px"
                                            >
                                                {/* {`Cart Items`} */}
                                                {t(
                                                    'reportUsage.summary.tissue'
                                                )}
                                            </UsagePriceFont>
                                            <UsagePriceFont
                                                color="#4F4F4F"
                                                fontSize="15px"
                                                letterSpacing="-0.12px"
                                                lineHeight="23px"
                                            >
                                                {/* {'$'}{tissuePrice} */}
                                                {tissuePrice
                                                    ? `${formatCurrency(
                                                          parseFloat(
                                                              tissuePrice
                                                          ).toFixed(2)
                                                      )}`
                                                    : setCurrencyFormat(
                                                          0,
                                                          true,
                                                          {
                                                              currency:
                                                                  currencyISOCode,
                                                          }
                                                      )}
                                            </UsagePriceFont>
                                        </UsagePricingDataContainer>
                                    ) : null}
                                    {nonTissuePrice || nonTissuePrice === 0 ? (
                                        <UsagePricingDataContainer
                                            margin={'0 0 5px 0'}
                                            justifyContent="space-between"
                                        >
                                            <UsagePriceFont
                                                color="#4F4F4F"
                                                fontSize="15px"
                                                letterSpacing="-0.12px"
                                                lineHeight="23px"
                                            >
                                                {/* {`Cart Items`} */}
                                                {ISOCountryCode !== 'US'
                                                    ? t('common.itemsLabel')
                                                    : t(
                                                          'equity.priceOverride.summaryConainer.nonTissue'
                                                      )}
                                            </UsagePriceFont>
                                            <UsagePriceFont
                                                color="#4F4F4F"
                                                fontSize="15px"
                                                letterSpacing="-0.12px"
                                                lineHeight="23px"
                                            >
                                                {/* {'$'}{nonTissuePrice} */}
                                                {nonTissuePrice
                                                    ? `${formatCurrency(
                                                          parseFloat(
                                                              nonTissuePrice
                                                          ).toFixed(2)
                                                      )}`
                                                    : setCurrencyFormat(
                                                          0,
                                                          true,
                                                          {
                                                              currency:
                                                                  currencyISOCode,
                                                          }
                                                      )}
                                            </UsagePriceFont>
                                        </UsagePricingDataContainer>
                                    ) : null}
                                    <UsagePricingDataContainer
                                        margin={'0 0 5px 0'}
                                        justifyContent="space-between"
                                    >
                                        <UsagePriceFont
                                            color="#4F4F4F"
                                            fontSize="16px"
                                            letterSpacing="-0.13px"
                                            lineHeight="23px"
                                            fontFamily="AvenirNextWorld Demi"
                                        >
                                            {t(
                                                'equity.priceOverride.summaryConainer.total'
                                            )}
                                        </UsagePriceFont>
                                        <UsagePriceFont
                                            color="#4F4F4F"
                                            fontSize="16px"
                                            letterSpacing="-0.13px"
                                            lineHeight="23px"
                                            fontFamily="AvenirNextWorld Demi"
                                        >
                                            {total
                                                ? `${formatCurrency(
                                                      parseFloat(total).toFixed(
                                                          2
                                                      )
                                                  )}`
                                                : setCurrencyFormat(0, true, {
                                                      currency: currencyISOCode,
                                                  })}
                                        </UsagePriceFont>
                                    </UsagePricingDataContainer>
                                </UsagePricingContainer>
                            </Card>
                        ) : null}
                        {pricingNotes && pricingNotes?.length > 0 ? (
                            <Card
                                padding={'10px 25px'}
                                margin={'10px 0 0 0'}
                            >
                                <UsagePricingContainer>
                                    <UsagePriceFont
                                        color="#140F4B"
                                        fontFamily="AvenirNextWorld Demi"
                                        margin={'0 0 15px 0'}
                                        fontSize="15px"
                                        letterSpacing="-0.12px"
                                    >
                                        {t(
                                            'orders.orderDetails.billingSummary.shippedItems.pricingNotes'
                                        )}
                                    </UsagePriceFont>

                                    <>
                                        {pricingNotes.map((notes, index) => {
                                            return (
                                                <UsagePricingDataContainer
                                                    key={notes.time}
                                                    margin={'0 0 2px 0'}
                                                >
                                                    <UsagePriceFont
                                                        color="#202124"
                                                        fontSize="15px"
                                                        lineHeight="18px"
                                                    >
                                                        {`${index + 1}. ${
                                                            notes.comments
                                                        }`}
                                                        {/* {notes.comments} */}
                                                    </UsagePriceFont>
                                                </UsagePricingDataContainer>
                                            );
                                        })}
                                    </>
                                </UsagePricingContainer>
                            </Card>
                        ) : null}
                    </>
                ) : null}
            </CollapsableCard>
        </>
    );
};

export default shippedItems;
